import { useState } from "react";
import { buttonVariants } from "@/components/ui/button";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import { cn } from "@/lib/utils";

const navLinks = [
  { label: "Product Tour", href: "#showcase" },
  { label: "Features", href: "#features" },
  { label: "FAQ", href: "#faq" },
];

export function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200/60">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <a href="#" className="flex items-center">
            <img
              src="/logo.svg"
              alt="ConsultNow"
              className="h-8 w-auto"
            />
          </a>

          {/* Desktop nav */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm font-semibold text-brand-navy/70 hover:text-brand-navy transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="/login"
              className="text-sm font-semibold text-brand-navy/70 hover:text-brand-navy transition-colors"
            >
              Login
            </a>
            <a
              href="#demo"
              className={cn(
                buttonVariants(),
                "bg-brand-red hover:bg-brand-red-dark text-white shadow-md shadow-brand-red/20"
              )}
            >
              Request a Demo
            </a>
          </div>

          {/* Mobile nav */}
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild className="lg:hidden">
              <Button variant="ghost" size="icon">
                <Menu className="h-5 w-5 text-brand-navy" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-72">
              <div className="flex flex-col gap-6 mt-8">
                {navLinks.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={() => setOpen(false)}
                    className="text-lg font-semibold text-brand-navy hover:text-brand-red transition-colors"
                  >
                    {link.label}
                  </a>
                ))}
                <a
                  href="/login"
                  onClick={() => setOpen(false)}
                  className="text-lg font-semibold text-brand-navy hover:text-brand-red transition-colors"
                >
                  Login
                </a>
                <a
                  href="#demo"
                  onClick={() => setOpen(false)}
                  className={cn(
                    buttonVariants(),
                    "w-full bg-brand-red hover:bg-brand-red-dark text-white"
                  )}
                >
                  Request a Demo
                </a>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </nav>
  );
}
